import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class TypesDisplayListCtrl implements IController {
  types: any;
  isRow: any;
  rowLimit: any;
  onChange: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    // if (this.ids && this.ids.length) {
    //
    // } else {
    //   this.displayItems = [];
    // }
  }

  $onChanges(changes) {
    if (changes.ids) {
      this.$onInit();
    }
  }

  onRemove(type) {
    this.onChange({types: _.filter(this.types, (t) => {return t !== type})});
  }



}

angular
  .module('bringoz.admin.deliveries')
  .component('typesDisplayList', {
    bindings: {
      types: '<',
      prefix: '@?',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./types-display-list.html').default,
    controller: TypesDisplayListCtrl
  });
